var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFloatingHeading2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heading"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_6002)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.5C4 5.22386 3.77614 5 3.5 5C3.22386 5 3 5.22386 3 5.5V14.5C3 14.7761 3.22386 15 3.5 15C3.77614 15 4 14.7761 4 14.5V10.5H10V14.5C10 14.7761 10.2239 15 10.5 15C10.7761 15 11 14.7761 11 14.5V5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V9.5H4V5.5ZM14.5334 9.11564C14.7372 9.00803 14.9718 8.97417 15.1977 9.01976C15.4235 9.06535 15.6268 9.18761 15.773 9.36593C15.9192 9.54426 15.9994 9.76771 16 9.99847L16 9.9995C16.0009 10.1938 15.9438 10.3839 15.8361 10.5454L13.0998 14.2003C12.9863 14.3519 12.9682 14.5545 13.0529 14.7238C13.1376 14.8931 13.3107 15 13.5 15H16.5C16.7761 15 17 14.7761 17 14.5C17 14.2239 16.7761 14 16.5 14H14.499L16.644 11.1349C16.6484 11.129 16.6528 11.1229 16.6569 11.1168C16.8821 10.7863 17.0017 10.3954 17 9.99551C16.9987 9.53462 16.8385 9.08826 16.5463 8.73187C16.2539 8.37535 15.8475 8.13075 15.3956 8.03953C14.9437 7.94831 14.4741 8.01608 14.0665 8.23136C13.6588 8.44663 13.338 8.79616 13.1583 9.22077C13.0507 9.47507 13.1696 9.76848 13.4239 9.8761C13.6782 9.98373 13.9716 9.86482 14.0792 9.61051C14.1691 9.39805 14.3296 9.22326 14.5334 9.11564Z",
    fill: "#596169"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 19.5,
    height: 19.5,
    rx: 1.75,
    stroke: "#DEE2E6",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_6002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingHeading2);
export default __webpack_public_path__ + "static/media/floating-heading2.6138ed6cf84c30e9a7ecb64689ab7566.svg";
export { ForwardRef as ReactComponent };